import InvitationsList from './entities/invitations-list';
import InvitationDetails from './entities/invitation-details';
import InvitationPreAccept from './entities/invitation-pre-accept';
import InvitationAccept from './entities/invitation-accept';

export default {
  modules: {
    InvitationsList,
    InvitationDetails,
    InvitationPreAccept,
    InvitationAccept,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/invitations/index.js